import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import {
  organizationSearchRequest,
  organizationSelect,
} from "../../redux/actions/organizations";
import Icon from "../Icon";

export default function ComboBox(props) {
  let { t, id } = props;
  const dispatch = useDispatch();

  const [showList, setShowList] = useState(false);
  const [value, setValue] = useState("");
  const [change, setChange] = useState(false);
  const list = useSelector((state) => state.organizations.list);
  const selectedOrganization = useSelector(
    (state) => state.organizations.selectedOrganization
  );
  useEffect(() => {
    if (selectedOrganization) {
      setValue(selectedOrganization.organizationName);
    }
  }, [selectedOrganization]);

  const elementSelect = (organization) => {
    setShowList(!showList);
    dispatch(organizationSelect(organization));
    setChange(false);
    setValue(organization.organizationName);
  };

  useEffect(() => {
    // annoy selection trigger
    if (change && Boolean(value)) {
      dispatch(organizationSearchRequest(value));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, change]);

  const inputChange = (e) => {
    setValue(e.target.value);
    setChange(true);
    setShowList(true);
  };

  // useEffect(() => {
  //   if (!Boolean(value)) {
  //     setValue("");
  //     dispatch(organizationSelect({}));
  //   }
  // }, []);

  const suffixIcon = () => {
    if (!value) return "search";
    else return "x";
  };
  const removeInput = () => {
    if (value) {
      setValue("");
      dispatch(organizationSelect({}));
      setChange(true);
    }
  };

  return (
    <div className="km__c--combobox-container">
      <div className="km__c--input-container">
        <input
          className="km__c--input km__c--input-has-icon"
          placeholder={t("ui.default.searchOrganization")}
          onClick={() => setShowList(!showList)}
          onChange={inputChange}
          value={value}
          id={id}
          autoComplete="off"
        />
        <Icon
          name={suffixIcon()}
          className="km__c--combobox-remove-button"
          onClick={removeInput}
          size="16"
        />
      </div>
      {list.length > 0 && showList && (
        <div className="km__c--combobox-list">
          {list.map((item, index) => {
            return (
              <div
                key={item.organizationId}
                className="km__c--combobox-element"
                onClick={() => {
                  elementSelect(item);
                }}
                id={`${id}-list-${index}`}
              >
                <div className="km__c--combobox-element-name">
                  {item.organizationName}
                </div>
                <div className="km__c--combobox-element-id">
                  ID: {item.organizationId}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
ComboBox.propTypes = {
  t: PropTypes.func,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
